import React from "react";
import LinkList from "../link-list";
// import Header from "../header";
import { Header } from "components";
import Markdown from "components/markdown";
import { Box, Grid } from "designsystem";
import { markdownWrapper } from "./styles/content.module.scss";
import FeedbackTool from "components/feedback/feedbacktool";

interface ContentProps {
  content: readonly GatsbyTypes.Maybe<
    | GatsbyTypes.ContentList_ContentfulHeader_Fragment
    | GatsbyTypes.ContentList_ContentfulMarkdown_Fragment
    | GatsbyTypes.ContentList_ContentfulLinkList_Fragment
    | GatsbyTypes.ContentList_ContentfulFeedbackTool_Fragment
  >[];
  localizedContent?: GatsbyTypes.LinkListNodeFragment[];
}
/**
 * This component is used in the Content Page to render different kinds of content
 * @param param0
 */
const Content: React.FC<ContentProps> = ({ content, localizedContent }) => {
  return (
    <Box direction="column">
      {content?.map((content, index) => {
        switch (content?.__typename) {
          case "ContentfulHeader":
            return <Header key={`content.title-${index}`} header={content} />;

          case "ContentfulLinkList":
            return (
              <Grid layout="content-sidebar" key={`content.title-${index}`}>
                <LinkList
                  linkList={content}
                  localizedContent={localizedContent?.filter(
                    (content) => content.contentful_id === content.contentful_id
                  )}
                />
              </Grid>
            );

          case "ContentfulMarkdown":
            return (
              content.childContentfulMarkdownBodyTextNode?.body && (
                <Grid layout="content-sidebar" key={`content.title-${index}`}>
                  <Box
                    direction="column"
                    gridArea="content"
                    paddingTop="xl"
                    paddingBottom="xl"
                    className={markdownWrapper}
                  >
                    <Markdown
                      content={
                        content.childContentfulMarkdownBodyTextNode?.body
                      }
                    />
                  </Box>
                </Grid>
              )
            );

          case "ContentfulFeedbackTool":
            return <FeedbackTool content={content} />;
        }
      })}
      {content.some(
        (content) => content?.__typename === "ContentfulFeedbackTool"
      ) ? (
        <></>
      ) : (
        <FeedbackTool />
      )}
    </Box>
  );
};
export default Content;
